// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconMoneyOutPath = 'M15.795 20.008H5.4v-12h19.2v8.4H27v-8.8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12.8a2 2 0 0 0 2 2h10.795v-2.4Zm-1.987-5.977a1.192 1.192 0 1 1 2.384 0 1.192 1.192 0 0 1-2.384 0ZM15 10.438a3.592 3.592 0 1 0 0 7.185 3.592 3.592 0 0 0 0-7.185Zm7.34 11.97-1.836 1.944L22.248 26l4.526-4.791-4.526-4.792-1.744 1.648 1.835 1.944h-4.333v2.4h4.333Z';
var NavigationIconMoneyOut = baseIcon('NavigationIconMoneyOut', {
  getPath: () => NavigationIconMoneyOutPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconMoneyOut;
//# sourceMappingURL=index.js.map